const joyride = (state = false, action) => {
    switch (action.type){
        case 'RUN_JOYRIDE':
            return action
        default:
            return state
    }
}

export default joyride
